module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_21.dot-164b25b71b82ad4f4b30405ceb48dfd3.svg";